import { ErrorMessage } from '@hookform/error-message';
import ErrorMessageStyle from 'Components/Form/ErrorMessageStyle';
import { SingleDateInput } from 'Components/Form/Inputs/DateInput';
import Label from 'Components/Form/Label';
import { Controller } from 'react-hook-form';

export interface IDateInputBasicProps extends Omit<IDateField, 'type'> {
  control?: any;
  labelIcon?: React.ReactNode;
  errors?: any;
  label?: string;
  type?: string;
  disabled?: boolean;
}

export default function DateInputBasic(props: IDateInputBasicProps) {
  const {
    name,
    control,
    label,
    labelIcon,
    errors,
    disabled,
    placeholder = 'Enter phone number',
    ...rest
  } = props;

  return (
    <>
      <Label label={label} labelIcon={labelIcon}>
        <Controller
          render={({ field }) => (
            <SingleDateInput
              disabled={disabled}
              value={field.value}
              placeholder={placeholder}
              onChange={field.onChange}
            />
          )}
          name={name}
          control={control}
          defaultValue=""
        />
        {errors && (
          <ErrorMessage
            errors={errors}
            name={name}
            render={({ message }) => <ErrorMessageStyle message={message} />}
          />
        )}
      </Label>
    </>
  );
}
